import React from "react";
import Home from "./Components/Home";
import About from "./Components/About";
import Education from "./Components/Education";
import Skills from "./Components/Skills";
import Contact from "./Components/Contact1";

function AllPages() {
  return (
    <>
    <Home />
    <About />
    <Education />
    <Skills />
    <Contact />
    </>
  );
}

export default AllPages;
